
<script setup>
  
  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { posterStyle } from '../stores/activity-5.js';

  import layoutPaths from '../images/activity-5-layout-*.svg';

  import backgroundPath from '../images/wood-background.jpg';

  const styles = [ {

    id: 1,

    label: 'Big Photo Style',

    alt: 'Panel with one large photo and two small photos.'

  }, {

    id: 2,

    label: 'Scrapbook Style',

    alt: 'Panel with three photos pinned to a bulletin board.'

  }, {

    id: 3,

    label: 'List Style',

    alt: 'Panel with a bold headline and three smaller photos.'

  } ]
  
  .map( obj => ( { ...obj, path: layoutPaths[ obj.id ] } ) );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-7xl">

          <div class="flex justify-center">

            <h2>

              <div class="text-xl tracking-narrow font-semibold uppercase">Step 3</div>

              <div class="text-4xl md:text-5xl font-heading uppercase">Choose a Panel Style</div>

            </h2>

          </div>

          <div class="flex flex-col lg:flex-row items-center justify-center mt-6 lg:mt-24 gap-6">

            <label v-for="{ id, label, path, alt } in styles"
            
              class="flex flex-col items-center px-2 pt-2 pb-6 border-4 border-transparent [&:has(:checked)]:border-green-700">

              <img :src="path" class="w-[420px]" :alt="alt" />

              <div class="flex items-center gap-3 mt-6">

                <input type="radio" :name="`poster-style-${ id }`" name="poster-style" v-model="posterStyle" :value="id" />

                <div class="grow font-heading text-3xl">{{ label }}</div>

              </div>

            </label>

          </div>

          <div class="flex flex-wrap justify-between gap-6 mt-12 lg:mt-24">

            <RouterLink
            
              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                  
                hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"

              to="/activity/5/step/2">
              
              <ArrowLeftCircleIcon class="w-8" />

              <span>Back</span>
            
            </RouterLink>

            <RouterLink

              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
              
                hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
            
              to="/activity/5/step/4">
              
              <span>Next</span>

              <ArrowRightCircleIcon class="w-8" />
            
            </RouterLink>

          </div>

        </div>

      </div>

    </div>

  </article>

</template>
